import React, { useCallback, useState, useMemo } from 'react';

import FilterBar from '../../../../components/filter-bar';
import { popularFilterByOptions as popularFilterReferences } from './filters';
import { useEnhancedReturnsContext } from './enhanced-returns-context';
import staticCriteriaArguments from './filters/static-criteria-arguments';
import EnhancedReturnsCriteriaOperatorsMap from './filters/custom-criteria-operators';
import { mapEnhancedReturnsFiltersToRequestBody } from '../map-enhanced-returns-to-api-params';
import { emptyArray } from 'ui-components/default-props/empty';
import { RETURNS_GRID_CLEAR_FILTER, RETURNS_GRID_SELECT_FILTER } from '../../../../constants/analytics-events';
import { Segment } from '../../../../services/analytics-services/segment';

import style from './filter-bar.module.less';

export const filterBar = 'returnsFilterBar';

export const EnhancedReturnsFilterBar = ({ viewSpecificFilters = emptyArray }) => {
  const { updateFilters } = useEnhancedReturnsContext();
  const [appliedFilters, setAppliedFilters] = useState([]);

  const onFiltersChanged = useCallback(
    (newlyAppliedFilters) => {
      setAppliedFilters(newlyAppliedFilters);

      const apiFilters = mapEnhancedReturnsFiltersToRequestBody(newlyAppliedFilters);
      Segment.trackEvent(RETURNS_GRID_SELECT_FILTER, {
        type: RETURNS_GRID_SELECT_FILTER,
        newlyAppliedFilters,
        apiFilters,
      });

      updateFilters(apiFilters);
    },
    [updateFilters],
  );

  const clearFilters = useCallback(() => {
    Segment.trackEvent(RETURNS_GRID_CLEAR_FILTER, {
      type: RETURNS_GRID_CLEAR_FILTER,
    });

    setAppliedFilters([]);
    updateFilters({});
  }, [updateFilters]);

  // Rather than build out ActionableFilterPills, we decided to just releverage DisplayName to accomplish the same task
  // However if we do have overflow filters and need to support non-radio, non-allowsMultipleSelection filters
  // this will end up display selected filter names in the overflow menu.
  const popularFilterByOptions = useMemo(
    () =>
      [...popularFilterReferences, ...viewSpecificFilters].map((filterBy) => ({
        ...filterBy,
        displayName: filterBy.displayName(appliedFilters),
      })),
    [viewSpecificFilters, appliedFilters],
  );

  return (
    <div className={style['filter-bar-wrapper']}>
      <FilterBar
        allFilterBys={popularFilterByOptions}
        appliedFilters={appliedFilters}
        clearFilters={clearFilters}
        criteriaArgumentsMap={staticCriteriaArguments}
        criteriaOperatorsMap={EnhancedReturnsCriteriaOperatorsMap}
        onFiltersChanged={onFiltersChanged}
        popularFilterBys={popularFilterByOptions}
        shouldUseOverflow={false}
        showOtherFilter={false}
      />
      <div className={style['filter-bar-actions-wrapper']} />
    </div>
  );
};
